import React, { FunctionComponent, useState } from "react"
import TextField from "@material-ui/core/TextField"

interface SearchInputProps {
    callback: (param: string) => void
}
export const SearchInput: FunctionComponent<SearchInputProps> = (props: SearchInputProps) => {
    const { callback } = props
    const [value, setValue] = useState("")

    const keyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            ;(e.target as HTMLInputElement).blur()
            callback(value)
        }
    }

    return (
        <TextField
            id="search"
            inputProps={{ "data-testid": "search" }}
            label="Find..."
            variant="outlined"
            fullWidth
            value={value}
            onChange={e => setValue(e.target.value)}
            onBlur={() => {
                callback(value)
            }}
            onKeyDown={keyPress}
        />
    )
}
